import { render } from "./sub.vue?vue&type=template&id=5a2bc88a&scoped=true"
import script from "./sub.vue?vue&type=script&lang=js"
export * from "./sub.vue?vue&type=script&lang=js"

import "./sub.vue?vue&type=style&index=0&id=5a2bc88a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2bc88a"]])

export default __exports__